export default __webpack_public_path__ + "static/media/logo@300x.22af631b.png";